import React, { useContext, useState } from "react";
import classes from "./Nav.module.css";
import resume from "../../../assets/resume.pdf";
import { BiMenuAltRight } from "react-icons/bi";
import { VscChromeClose } from "react-icons/vsc";
import { BsFillMoonFill, BsFillSunFill } from "react-icons/bs";

import NavItem from "./navItem/NavItem";

import { itemDetails } from "./navItem/navItemDetails";
import { ThemeContext } from "../../../ThemeProvider";

import { motion } from "framer-motion";

const Nav = ({ customClass }) => {
  const [menuToggle, setMenuToggler] = useState(false);

  const { dark, themeToggler } = useContext(ThemeContext);

  const animateFrom = { opacity: 0, y: -40 };
  const animateTo = { opacity: 1, y: 0 };

  return (
    <nav className={customClass}>
      <div className={classes.nav__bar}>
        <ul>
          {itemDetails.map((item) => (
            <NavItem
              key={item.num}
              offset={item.offset}
              to={item.to}
              name={item.name}
              num={item.num}
              delay={item.delay}
            />
          ))}
          <motion.li
            initial={animateFrom}
            animate={animateTo}
            transition={{ delay: 0.45, duration: 0.5, type: "tween" }}
            className={
              dark
                ? `${classes.nav__resume} ${classes.nav__resume__dark}`
                : classes.nav__resume
            }
          >
            <a href={resume} download>
              Resume
            </a>
          </motion.li>
          <motion.li
            initial={animateFrom}
            animate={animateTo}
            transition={{ delay: 0.5, duration: 0.5, type: "tween" }}
          >
            <div className={classes.nav__theme}>
              {dark ? (
                <div
                  className={
                    dark
                      ? `${classes.theme__icon} ${classes.theme__icon__dark}`
                      : classes.theme__icon
                  }
                  onClick={themeToggler}
                >
                  <BsFillSunFill />
                </div>
              ) : (
                <div
                  className={
                    dark
                      ? `${classes.theme__icon} ${classes.theme__icon__dark}`
                      : classes.theme__icon
                  }
                  onClick={themeToggler}
                >
                  <BsFillMoonFill />
                </div>
              )}
            </div>
          </motion.li>
        </ul>
      </div>

      {!menuToggle ? (
        <BiMenuAltRight
          className={
            dark
              ? `${classes.menu__toggle__btn} ${classes.menu__toggle__btn__dark}`
              : classes.menu__toggle__btn
          }
          onClick={() => setMenuToggler((prev) => !prev)}
        />
      ) : (
        <VscChromeClose
          className={
            dark
              ? `${classes.menu__toggle__btn} ${classes.menu__toggle__btn__dark}`
              : classes.menu__toggle__btn
          }
          onClick={() => setMenuToggler((prev) => !prev)}
        />
      )}
    </nav>
  );
};

export default Nav;
